<template>
  <div class="navContainer">
    <nav class="main">
      <div class="clearfix container">
        <div class="fl">
          <router-link to="/" style="display: inline-block;">
            <img :src="url+webInfo.siteLogo" alt="logo" />
          </router-link>
        </div>
        <div class="fr">
          <div class="navLIst">
            <ul>
              <li v-for="(item,i) in navList" :key="i">
                <router-link v-if="item.isOutLink != 1" class="transt" :to="item.siteUrl">{{item.title}}</router-link>

                <a v-else href="javascript:void(0)" class="transt" @click="goNewPage(item)">{{item.title}}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
    <Messages ref="messages" :tips="tipsTxt" />
  </div>
</template>

<script>
import {outLogin,getNavList} from "@/api/index.js"
import Messages from "@/components/Messages"
import { mapState } from 'vuex';
export default {
  data() {
    return {
      navList:[],
      navShow:false,
      tipsTxt:"",
      url: process.env.PATH_IMG,
      screenWidth: document.body.clientWidth,
      timer:false,
    }
  },
  components:{
    Messages,
  },
  computed: {
    key() {
      return this.$route.path;
    },
    userData(){
      let data = {};
      if(this.$store.state.IsLogin && this.$store.state.userObj){
        data = this.$store.state.userObj;
        data["avatarUrl"] = data.headPortraitUrl?this.url+data.headPortraitUrl:require("@/assets/images/user/avatar.png");
        data["name"] = data.nickname?data.nickname:((data.mobile).substring(7,11));
      }
      return data;
    },
    webInfo(){
      let data = {};
      if(this.$store.state.infoData){
        data = this.$store.state.infoData;
      }
      return data;
    },
    ...mapState(['IsLogin']),
  },
  mounted(){
    this.getData();
  },
  methods:{
    goNewPage(cur){
      if(cur.isBlank == 1 && cur.isOutLink == 1){//是否新窗口打开 1、是 0、否
        window.open(cur.siteUrl);
      }else{
        if(cur.isOutLink == 1){
          window.location.href = cur.siteUrl;
        }else{
          this.$router.push(cur.siteUrl+'?name='+cur.title);
        }
      }
    },
    getData(){
      getNavList({
        nkey:"top",
      }).then(res=>{
        if(res.data.success){
          let navList = res.data.obj.filter((im,i)=>{
            if(im.isOutLink == 0){//是否允许外链 1、是 0、否
              im["flag"] = true;
            }else{
              im["flag"] = false;
            }
            return im;
          });

          var compare = function (obj1, obj2) {
            var val1 = obj1.sort;
            var val2 = obj2.sort;
            if (val1 < val2) {
                return -1;
            } else if (val1 > val2) {
                return 1;
            } else {
                return 0;
            }            
          } 
          
          this.navList = navList.sort(compare);
        }else{
          if(res.data.msg && res.data.msg!=""){
            this.$message({
              type: "warning",
              message: res.data.msg,
            });
          }
        }
      }).catch(err=>{
        console.log(err)
      });
    },
    goPages(){
      this.$router.push("/user");
    },
    outLogins(){
      outLogin({}).then((res) => {
        if(res.data.success){
          this.tipsTxt = "已退出登录";
          this.$refs.messages.show = true;
          this.$store.dispatch("OutLogin");
        }
      });
    },
  }
}
</script>

<style lang="less" scoped>
    .navContainer{
      width: 100%;
      height: auto;
      //background-color: rgba(255, 255, 255, 0.8);
      background-color: #fff8f1;
      position: relative;
      .main{
        height: 140px;
        .navLIst{
          color: #120303;
          text-align: left;
          display: inline-block;
          padding-right: 20px;
          height: 100%;
          vertical-align: top;
          position: relative;
          dl{
            position: absolute;
            top: 140px;
            right: -60px;
            width: 160px;
            border-radius: 4px;
            padding:8px 0px;
            background-color: #fff;
            box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.2);
            z-index: 10;
            dd{
              line-height: 30px;
              height: 30px;
              cursor: pointer;
              padding-left: 25px;
              padding-right: 20px;
              a{
                display: inline-block;
                height: 100%;
                color: #333;
              }
            }
            dd:hover{
              background-color: #eee;
              border-bottom: 1px solid #ddd;
            }
          }
          dd::after{
            content: "";
            display: inline-block;
            position: absolute;
            top: -9px;
            left: 70px;
            width: 18px;
            height: 18px;
            background-color: #fff;
            display: inline-block;
            transform: rotate(45deg);
            -ms-transform: rotate(45deg);
            -moz-transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
            -o-transform: rotate(45deg);
          }
          ul{
            height: 100%;
            li{
              display: inline-block;
              height: 100%;
              font-size: 24px;
              line-height: 140px;
              margin: 0 20px;
              vertical-align: top;
              position: relative;
              >a{
                height: 100%;
                display: inline-block;
                position: relative;
                span{
                  height: 100%;
                  display: inline-block;
                  vertical-align: top;
                }
              }
              >a:hover{
                color: #a30014;
              }
              >a:hover::after{
                display: block;
                width: 100%;
              }
              >a::after{
                transition: all 0.5s;
                content: "";
                display: block;
                height: 1px;
                width: 0;
                background-color: #a30014;
                position: absolute;
                bottom: 54px;
                left: 0;
              }
              .router-link-active::after{
                display: block;
                width: 100%;
              }
              .router-link-active{
                color: #a30014;
              }
              .el-icon-s-unfold{
                font-size: 25px;
                line-height: 140px;
                display: inline-block;
              }
            }
          }
          
          li:last-child{
            margin-right: 0;
          }
        }
        .clearfix{
          height: 100%;
          // display: flex;
          // justify-content: space-between;
          .fl{
            position: relative;
            padding: 17px 0;
            height: 100%;
            display: flex;
            align-items: center;
            a{
              display: inline-block;
              img{
                vertical-align: middle;
                display: inline-block;
              }
              i{
                display: inline-block;
                margin: 0 20px;
              }
              i::after{
                content: "";
                display: inline-block;
                width: 1px;
                height: 50px;
                background-color: #919191;
                position: absolute;
                top: 16px;
              }
            }
          }
          .fr{
            font-size: 14px;
            height: 100%;
            .goLogin{
              line-height: 144px;
              display: inline-block;
              height: 100%;
              color: #E93005;
              span{
                padding: 0 5px;
              }
              a{
                display: inline-block;
                text-align: center;
                
              }
            }
            .login{
              display: inline-block;
              height: 100%;
              .userInfo{
                position: relative;
                height: 100%;
                ul{
                  display: none;
                  position: absolute;
                  top: 100px;
                  left: 0;
                  background-color: #fff;
                  z-index: 30;
                  border: 1px solid #f8f8f8;
                  padding: 5px 12px;
                  -webkit-box-shadow:0 0 10px rgba(209, 209, 209, 0.5);
                  -moz-box-shadow:0 0 10px rgba(209, 209, 209, 0.5);
                  box-shadow:0 0 10px rgba(209, 209, 209, 0.5);
                  li{
                    cursor: pointer;
                    height: 30px;
                    line-height: 30px;
                    line-height: 30px;
                    height: 30px;
                    font-size: 0;
                    span{
                      font-size: 12px;
                      vertical-align: middle;
                    }
                    i{
                      font-size: 14px;
                      vertical-align: middle;
                      margin-right: 8px;
                      font-weight: bold;
                    }
                  }
                  li:hover{
                    color: #bd3535;
                  }
                }
                a::after{
                  display: none!important;
                }
                a{
                  display: inline-block;
                  margin-right: 0!important;
                  height: 100%;
                  img{
                    width: 40px;
                    height: 40px;
                    vertical-align: top;
                    margin: 52px 0;
                    margin-right: 5px;
                    border-radius: 50%;
                    box-shadow: 0 0 6px 5px rgba(0, 0, 0, 0.05);
                  }
                  span{
                    vertical-align: top;
                    display: inline-block;
                    line-height: 144px;
                    font-size: 14px;
                  }
                  i{
                    line-height: 144px;
                    display: inline-block;
                    font-size: 16px;
                  }
                }
              }
              .userInfo:hover{
                ul{display: block;}
              }
            }
          }
        }
      }
      
      
    }
</style>


// WEBPACK FOOTER //
// src/layout/components/TopMenu.vue